module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/react-google-maps/~/babel-runtime/core-js/object/assign.js
// module id = 2205
// module chunks = 0